import "../../../callout.js";
import "#/shared/api/api-host-global.js";
import "../../../../../../utilities/iso_date.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.VisitStep ??= {};

AppointmentBooking.Wizard.Views.VisitStep.NotLicensedForLocationCallout = class NotLicensedForLocationCallout extends (
  AppointmentBooking.Wizard.Views.Callout
) {
  constructor() {
    super(...arguments);
    this.contextForRender = this.contextForRender.bind(this);
    this.buildLicensedProviderSearchUrl = this.buildLicensedProviderSearchUrl.bind(this);
  }

  // RENDERING

  contextForRender() {
    const context = super.contextForRender(...arguments);
    context["licensed_provider_search_url"] = this.buildLicensedProviderSearchUrl();

    return context;
  }

  // HELPER METHODS

  buildLicensedProviderSearchUrl() {
    const slot = this.model.get("appointment_slot");
    const provider = this.model.get("provider");

    if (!slot || !provider) {
      return;
    }

    const link = jQuery("<a>").attr("href", this.doctorFinderBaseUrl)[0];
    const params = {
      availability: true,
      visit_types: slot.visit_type_id,
      slots_ui_start_date: Sparkle.Utilities.isoDate(moment(slot.start_time)),
      specialty_scope: _.pluck(provider.specialties, "id").join(this.specialtyScopeDelimiter),
      licensed_location_scope: this.model.get("location_during_visit"),
    };

    link.search = jQuery.param(params);

    return jQuery(link).attr("href");
  }
};
AppointmentBooking.Wizard.Views.VisitStep.NotLicensedForLocationCallout.prototype.template =
  "step/visit/callouts/not_licensed_for_location";

AppointmentBooking.Wizard.Views.VisitStep.NotLicensedForLocationCallout.prototype.doctorFinderBaseUrl = window.Sparkle
  .apiHost
  ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.physicians
  : undefined;

AppointmentBooking.Wizard.Views.VisitStep.NotLicensedForLocationCallout.prototype.specialtyScopeDelimiter =
  window.SparkleConfig.physicianSearch.specialtyScopeDelimiter;
